import React from 'react';
import PropTypes from 'prop-types';
import { Box, Divider } from '@mui/material';
import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    padding: '24px 0px',
    gap: 10
  },
  lineContainer: {
    position: 'relative',
    width: '100%',
    height: 6,
    display: 'flex',
    alignItems: 'center'
  },
  activeDivider: {
    height: 6,
    backgroundColor: 'var(--mdui-circular-progress-color, rgb(6, 110, 130))',
    borderRadius: 30,
    border: 'none',
    position: 'absolute',
    left: 0,
    transition: 'width 0.3s ease'
  },
  inactiveDivider: {
    height: 6,
    backgroundColor: 'rgb(var(--mdui-color-outline-variant))',
    borderRadius: 30,
    border: 'none',
    position: 'absolute',
    transition: 'width 0.3s ease, left 0.3s ease'
  },
  endDot: {
    position: 'absolute',
    top: '50%',
    right: 4,
    transform: 'translate(50%, -50%)',
    width: 5,
    height: 5,
    borderRadius: '50%',
    backgroundColor: 'var(--mdui-circular-progress-color, rgb(6, 110, 130))',
    zIndex: 2
  }
}));

function Stepper({ steps, currentStep = 1 }) {
  const classes = useStyles();
  const totalSteps = steps.length;

  const maxProgress = 60;
  const progressPercent = (currentStep / totalSteps) * maxProgress;

  const activeWidth = `${progressPercent}%`;
  const gapWidth = 8;
  const inactiveLeft = `calc(${activeWidth} + ${gapWidth}px)`;
  const inactiveWidth = `calc(100% - ${activeWidth} - ${gapWidth}px)`;

  return (
    <Box className={classes.root}>
      <Box className={classes.lineContainer}>
        <Divider
          className={classes.activeDivider}
          style={{
            width: activeWidth
          }}
        />
        <Divider
          className={classes.inactiveDivider}
          style={{
            left: inactiveLeft,
            width: inactiveWidth
          }}
        />
        <div className={classes.endDot} />
      </Box>
    </Box>
  );
}

Stepper.propTypes = {
  steps: PropTypes.arrayOf(PropTypes.string).isRequired,
  currentStep: PropTypes.number
};

export default Stepper;
